import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { em } from 'polished';
import { isEmpty, startCase } from 'lodash';
import {
  DetailsHeading,
  EmailLink,
  PhoneLink,
  SecondaryTitle,
} from '../../common';
import { appTheme } from '../../../theme';
import { formatAddress } from '../../../util/helpers';

const Wrapper = styled.div`
  margin-bottom: 1em;
`;

const EmergencyContacts = styled.div`
  margin-top: ${em(appTheme.spacing.large)};
`;

const PlaceholderText = styled.p`
  color: ${appTheme.system.title};
  font-style: italic;
`;

function Caregiver({
  addressState,
  city,
  email,
  firstName,
  lastName,
  primaryPhoneNumber,
  relationship,
  secondaryStreetAddress,
  streetAddress,
  zipCode,
  notes,
}) {
  return (
    <Wrapper>
      <DetailsHeading>
        {`${firstName} ${lastName} ${
          !!relationship ? `(${startCase(relationship)})` : ``
        }`}
      </DetailsHeading>
      <div>{streetAddress}</div>
      <div>{secondaryStreetAddress}</div>
      <div>{formatAddress(city, addressState, zipCode)}</div>
      <PhoneLink tel={primaryPhoneNumber} />
      <EmailLink mailto={email} />
      {notes && (
        <div>
          {<span>Notes: </span>}
          {notes}
        </div>
      )}
    </Wrapper>
  );
}

const caregiverPropTypes = {
  addressState: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  primaryPhoneNumber: PropTypes.string.isRequired,
  relationship: PropTypes.string.isRequired,
  streetAddress: PropTypes.string.isRequired,
  zipCode: PropTypes.string.isRequired,
  notes: PropTypes.string,
  secondaryStreetAddress: PropTypes.string,
};

Caregiver.propTypes = caregiverPropTypes;

Caregiver.defaultProps = {
  secondaryStreetAddress: '',
};

function PrimaryCaregiverDetails({ emergencyContacts, ...rest }) {
  return (
    <div>
      <Caregiver {...rest} />
      <SecondaryTitle>Emergency Contacts</SecondaryTitle>
      {isEmpty(emergencyContacts) ? (
        <PlaceholderText>
          No emergency contacts have been added.
        </PlaceholderText>
      ) : (
        <EmergencyContacts>
          {emergencyContacts.map(contact => (
            <Caregiver {...contact} key={contact.id || contact.tempId} />
          ))}
        </EmergencyContacts>
      )}
    </div>
  );
}

PrimaryCaregiverDetails.propTypes = {
  ...caregiverPropTypes,
  emergencyContacts: PropTypes.arrayOf(PropTypes.shape(caregiverPropTypes)),
};

PrimaryCaregiverDetails.defaultProps = {
  emergencyContacts: [],
  secondaryStreetAddress: '',
};

export default PrimaryCaregiverDetails;



// WEBPACK FOOTER //
// ./src/modules/PrimaryCaregiverPage/components/PrimaryCaregiverDetails.js